<script lang="ts">
	import { appState } from '$lib/app-state.svelte'
	import { findParentRecord } from '$lib/lists'
	import { cartItems } from '$lib/stores.svelte'

	interface Props {
		productId: number
		label?: string
		title?: string
		disabled?: boolean
	}

	let {
		productId,
		label = 'Add to Cart',
		title = 'Add to cart button',
		disabled = false
	}: Props = $props()

	const addItem: AddItemResult = (productId: number) => {
		const lookupResult = findParentRecord(appState.products, productId)
		if (!lookupResult) throw new Error(`Error: product ID ${productId} not found.`)
		const product = lookupResult as Product
		const item: CartItem | undefined = $cartItems.find(
			(element: CartItem) => element.product.id === productId
		)
		if (!item) {
			$cartItems = [...$cartItems, { product, quantity: 1 }]
		} else {
			item.quantity++
			$cartItems = $cartItems // notifies subscribers
		}

		document.getElementById('cart')?.click() // open cart offcanvas by clicking button in menu
	}
</script>

<button id="product{productId}" onclick={() => addItem(productId)} {title} {disabled}>
	{label}
</button>
